var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTableArrows(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6464 9.14493C10.8417 8.9497 11.1582 8.9497 11.3534 9.14493C11.5486 9.34017 11.5487 9.65667 11.3534 9.85185L7.5302 13.6745C7.23736 13.9672 6.76253 13.9672 6.46966 13.6745L2.64641 9.85185C2.45117 9.65664 2.45122 9.34017 2.64641 9.14493C2.84168 8.9497 3.15818 8.9497 3.35344 9.14493L6.99993 12.7909L10.6464 9.14493Z",
    fill: "#3D3D3C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.52678 0.271755C6.82136 0.0315481 7.25562 0.0484962 7.5302 0.323017L11.3534 4.14568C11.5486 4.34093 11.5487 4.65742 11.3534 4.85261C11.1582 5.04773 10.8417 5.04767 10.6464 4.85261L6.99993 1.20667L3.35344 4.85261C3.15822 5.04773 2.84166 5.04767 2.64641 4.85261C2.45117 4.6574 2.45122 4.34092 2.64641 4.14568L6.46966 0.323017L6.52678 0.271755Z",
    fill: "#3D3D3C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableArrows);
export default __webpack_public_path__ + "static/media/table-arrows.b2d14ed6cc8eadaaf4d65c9af9581d4a.svg";
export { ForwardRef as ReactComponent };